module.exports = __webpack_public_path__ + "static/media/odonto.9806576e.png";